import React from 'react';
import SeriesForm from '../Components/SeriesForm';

const AddSeries = () => {
  return (
    <div>
      <SeriesForm />
    </div>
  );
};

export default AddSeries;
